"use client";

import React from "react";
import { Sparkles, ShieldCheck, Clock, MapPin, Flame, Wrench, CircleCheck as CheckCircle2, PhoneCall, MessageCircle, Layers, Users as Users2, CalendarCheck } from 'lucide-react';
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
import { PHONE_LOCAL, PHONE_TEL_HREF, WHATSAPP_HREF } from "@/lib/contact";
const serviceFeatures = [{
  title: "تنظيف غرف وأفران الطهي بعمق",
  description: "إزالة كاملة للدهون المتراكمة والأوساخ المستعصية من تجويف الفرن الداخلي دون الإضرار بطلاء المينا أو حساسات الإشعال.",
  icon: Flame
}, {
  title: "جلي الشوايات وصواني التحمير",
  description: "إذابة ترسبات الكربون المحترق من الشبك والأسياخ والصواني المعدنية وإعادتها لمظهرها الأصلي ولمعانها الطبيعي.",
  icon: Sparkles
}, {
  title: "تفكيك وتنظيف زجاج الأبواب",
  description: "فك الزجاج المزدوج والثلاثي بعناية تامة لإزالة الأبخرة والدهون العالقة بين الطبقات لضمان رؤية نقية تماماً.",
  icon: Layers
}, {
  title: "مواد متطورة وآمنة 100%",
  description: "استخدام منظفات معتمدة تزيل التكلسات والشحوم بفعالية عالية وبشكل آمن على الأسطح والمكونات الداخلية والصحة العامة.",
  icon: ShieldCheck
}];
const credentials = [{
  title: "سمعة موثوقة في حي الملقا",
  description: "خبرة طويلة وسجل حافل من التقييمات الإيجابية لدى مئات المنازل والفلل السكنية داخل حي الملقا.",
  icon: Users2
}, {
  title: "سرعة استجابة فائقة",
  description: "فرق عمل ميدانية متواجدة باستمرار في شمال الرياض لضمان الوصول السريع لموقعكم في الوقت المحدد.",
  icon: Clock
}, {
  title: "فنيون محترفون ومدربون",
  description: "طاقم فني متخصص في التعامل الدقيق مع كافة ماركات الأفران الغازية والكهربائية والإيطالية والحديثة.",
  icon: Wrench
}, {
  title: "مواد آمنة ومختبرة",
  description: "مركبات تنظيف مخصصة للأجهزة الغذائية، غير كاوية، تحافظ على دهان الفرن وخالية من الروائح النفاذة.",
  icon: CheckCircle2
}];
const coverageDistricts = ["حي الملقا (تغطية رئيسية مباشرة)", "حي حطين", "حي الصحافة", "حي الياسمين", "حي النخيل", "حي العقيق"];
const faqs = [{
  id: "item-1",
  question: "كم مرة يُنصح بتنظيف وغسيل الفرن بشكل عميق؟",
  answer: "نوصي بإجراء تنظيف شامل للفرن المنزلي كل 3 إلى 6 أشهر للحفاظ على كفاءة التسخين، وتجنب انبعاث الروائح والدخان أثناء الطهي، وضمان سلامة نظام الإشعال."
}, {
  id: "item-2",
  question: "كم تستغرق مدة زيارة تنظيف وصيانة الفرن المنزلية؟",
  answer: "تستغرق الزيارة الميدانية القياسية عادة ما بين 60 إلى 90 دقيقة بحسب حجم الفرن وحالة الدهون المتراكمة، ويتم تنفيذ كامل العمل داخل مطبخكم بمنتهى النظافة والترتيب."
}, {
  id: "item-3",
  question: "هل خدمتكم متوافقة مع جميع أنواع الأفران ومصادر الطاقة؟",
  answer: "نعم، نقدم الخدمة لكافة أنواع الأفران سواء كانت غازية أو كهربائية مدمجة (Built-in) أو أفران قائمة، بما يشمل مختلف الماركات العالمية مثل أريستون، جليم غاز، الخزف، وإلبا."
}, {
  id: "item-4",
  question: "كيف يمكنني حجز موعد لتنظيف الفرن في حي الملقا؟",
  answer: `يمكنك الحجز فوراً عبر التواصل مباشرة عبر الواتساب أو الاتصال الهاتفي برقم الخدمة ${PHONE_LOCAL}، وسيقوم فريق خدمة العملاء بتحديد الموعد المناسب لزيارتكم في حي الملقا أو الأحياء المجاورة.`
}];
export default function OvenCleaningAlMulqaService() {
  return <section id="ovencleaningalmulqaservice" data-nav="light" dir="rtl" className="bg-background text-foreground py-16 md:py-24 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-20">
        
        {/* Block 1: Service Scope */}
        <div className="space-y-10">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 mb-3">
              <Badge variant="outline" className="border-primary/30 text-primary bg-primary/5 font-medium px-3 py-1">
                خدمات تنظيف الأفران بحي الملقا
              </Badge>
              <div className="w-8 h-[3px] bg-primary rounded-full" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
              تنظيف وتلميع احترافي للأفران يزيل الدهون ويعيد اللمعان
            </h2>
            <p className="mt-4 text-base md:text-lg text-muted-foreground leading-relaxed">
              خدمة تنظيف عميق ومتكاملة في حي الملقا بالرياض تشمل حجرة الفرن، الصواني، الشوايات، والواجهات الزجاجية، باستخدام منظفات قوية ومتطورة لا تؤثر على طلاء الهيكل أو القطع الحساسة.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {serviceFeatures.map((item, index) => {
            const IconComponent = item.icon;
            return <Card key={index} data-index={index} className="bg-card border-border hover:border-primary/40 transition-colors shadow-xs">
                  <CardHeader className="space-y-3">
                    <div className="size-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
                      <IconComponent className="size-6" />
                    </div>
                    <CardTitle className="text-lg font-semibold">{item.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-sm leading-relaxed text-muted-foreground">
                      {item.description}
                    </CardDescription>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>

        {/* Block 2: Why Choose لمسة احتراف */}
        <div className="space-y-10 pt-4 border-t border-border/60">
          <div className="max-w-3xl">
            <Badge variant="secondary" className="mb-3 px-3 py-1 text-secondary-foreground font-medium">
              لماذا يختارنا سكان حي الملقا؟
            </Badge>
            <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-foreground">
              معايير عالية وخبرة موثوقة في صيانة ونظافة الأفران المنزلية
            </h2>
            <p className="mt-3 text-muted-foreground text-base">
              نلتزم بتقديم خدمة منزلية ممتازة تجمع بين الخبرة الميدانية، الأمان الكامل للأجهزة، والاهتمام الفائق بنظافة المطبخ.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {credentials.map((cred, index) => {
            const IconComponent = cred.icon;
            return <Card key={index} data-index={index} className="bg-muted/40 border-border hover:bg-card transition-colors shadow-none">
                  <CardHeader className="space-y-3">
                    <div className="size-11 rounded-lg bg-secondary text-secondary-foreground flex items-center justify-center">
                      <IconComponent className="size-5" />
                    </div>
                    <CardTitle className="text-lg font-semibold">{cred.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-sm leading-relaxed text-muted-foreground">
                      {cred.description}
                    </CardDescription>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>

        {/* Block 3: Service Coverage */}
        <div className="bg-card rounded-2xl border border-border p-6 md:p-10 shadow-xs">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-7 space-y-4">
              <div className="inline-flex items-center gap-2 text-primary text-sm font-semibold">
                <MapPin className="size-4 shrink-0" />
                <span>نطاق التغطية والوصول الميداني</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground">
                تغطية متخصصة لحي الملقا ومناطق شمال الرياض
              </h2>
              <p className="text-muted-foreground leading-relaxed text-base">
                نقدم خدمة منزلية مباشرة داخل حي الملقا مع تواجد مستمر لفرقنا المتنقلة لتلبية طلبات الصيانة والغسيل الفوري في الحي والأحياء المجاورة دون الحاجة لنقل الأجهزة خارج المنزل.
              </p>
              
              <div className="pt-2 grid grid-cols-2 sm:grid-cols-3 gap-3">
                {coverageDistricts.map((district, i) => <div key={i} data-index={i} className="flex items-center gap-2 text-sm text-foreground bg-muted/60 px-3 py-2 rounded-md border border-border/50">
                    <CheckCircle2 className="size-4 text-primary shrink-0" />
                    <span className="truncate">{district}</span>
                  </div>)}
              </div>
            </div>

            <div className="lg:col-span-5 bg-muted/50 rounded-xl p-6 border border-border space-y-4">
              <h3 className="font-semibold text-foreground flex items-center gap-2">
                <Clock className="size-5 text-primary" />
                <span>مميزات الخدمة المنزلية السريعة</span>
              </h3>
              <ul className="space-y-3 text-sm text-muted-foreground">
                <li className="flex items-start gap-2">
                  <span className="size-1.5 rounded-full bg-primary mt-2 shrink-0" />
                  <span>وصول الفني بمعدات التنظيف المتكاملة إلى باب منزلك في الموعد المحدد.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="size-1.5 rounded-full bg-primary mt-2 shrink-0" />
                  <span>حماية كاملة لأرضيات وخزائن المطبخ المحيطة أثناء مراحل العمل.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="size-1.5 rounded-full bg-primary mt-2 shrink-0" />
                  <span>فحص كفاءة شعلات الغاز وتوصيلات الكهرباء بعد الانتهاء للتأكد من السلامة.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Block 4: FAQ Section */}
        <div className="max-w-4xl mx-auto space-y-8 pt-4">
          <div className="text-center space-y-3">
            <Badge variant="outline" className="border-border text-foreground px-3 py-1">
              الأسئلة الشائعة
            </Badge>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground">
              كل ما تود معرفته عن خدمة تنظيف الأفران بحي الملقا
            </h2>
            <p className="text-muted-foreground text-sm md:text-base">
              إجابات موجزة لأبرز استفسارات العملاء حول أسلوب عملنا ومدة الخدمة وطريقة الحجز.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full bg-card rounded-xl border border-border px-6 py-2 shadow-xs">
            {faqs.map(faq => <AccordionItem key={faq.id} value={faq.id} className="border-border py-1">
                <AccordionTrigger className="text-base font-medium text-foreground hover:no-underline hover:text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm leading-relaxed pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        {/* Block 5: Call to Action Block */}
        <div className="rounded-2xl bg-secondary text-secondary-foreground p-8 md:p-12 text-center border border-border shadow-md">
          <div className="max-w-2xl mx-auto space-y-6">
            <div className="inline-flex items-center justify-center size-12 rounded-full bg-white/10 mx-auto">
              <CalendarCheck className="size-6 text-secondary-foreground" />
            </div>
            
            <div className="space-y-3">
              <h2 className="text-2xl md:text-3xl font-bold tracking-tight">
                احجز موعد تنظيف فرنك في حي الملقا الآن
              </h2>
              <p className="text-secondary-foreground/80 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
                فريقنا المتخصص في شركة لمسة احتراف جاهز لخدمتكم فوراً داخل حي الملقا وشمال الرياض. تواصل معنا للاستفسار أو تحديد موعد يناسبك.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
              <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 font-medium px-8 shadow-xs">
                <Link to={WHATSAPP_HREF} newTab className="flex items-center justify-center gap-2">
                  <MessageCircle className="size-5 shrink-0" />
                  <span>تواصل عبر الواتساب</span>
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto bg-white/10 text-secondary-foreground hover:bg-white/20 border-white/20 font-medium px-6">
                <a href={PHONE_TEL_HREF} className="flex items-center justify-center gap-2">
                  <PhoneCall className="size-4 shrink-0" />
                  <span>اتصال مباشر: {PHONE_LOCAL}</span>
                </a>
              </Button>
            </div>
          </div>
        </div>

      </div>
    </section>;
}